
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

const Testimonial = () => {
  const { t } = useTranslation();
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-left" />
      </button>
    );
  }
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };
  return (
    <section id="testimonials" className="testimonial padding-b-120 position-relative  overflow-hidden">
      {/* <img
        src="/assets/images/gradients/featured-gradient.png"
        alt=""
        className="bg--gradient white-version"
      /> */}
      
      <div className="container container-two">
        <div className="section-heading style-left style-flex flx-between align-items-end gap-3">
          <div className="section-heading__inner w-lg">
            <h3 className="section-heading__title">{t("testimonial.title")}</h3>
          </div>
          
        </div>
        <div className="testimonial-slider">
          <Slider {...settings}>
            <div className="testimonial-item hover-bg-main"> 
              <div className="testimonial-item__rating mb-3">
                <ul className="star-rating">
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                </ul>
              </div>
              <p className="testimonial-item__desc">
                {t("testimonial.feedbacks.0.feedback")}
              </p>
              <div className="testimonial-item__quote">
                <img
                  src="/assets/images/icons/quote.svg"
                  alt=""
                  className="quote quote-white"
                />
                <img
                  src="/assets/images/icons/quote-dark.svg"
                  alt=""
                  className="quote quote-dark"
                />
              </div>
              <div className="client-info d-flex align-items-center gap-3">
                <div className="client-info__thumb">
                  <img src="/assets/images/avatars/avatar-5.png" alt="" />
                </div>
                <div className="client-info__content">
                  <h5 className="client-info__name mb-2">{t("testimonial.feedbacks.0.author")}</h5>
                </div>
              </div>
            </div>
            <div className="testimonial-item hover-bg-main">
              {/* <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg white-version"
              />
              <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg dark-version"
              /> */}
              <div className="testimonial-item__rating mb-3">
                <ul className="star-rating">
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                </ul>
              </div>
              <p className="testimonial-item__desc">
                {t("testimonial.feedbacks.1.feedback")}
              </p>
              <div className="testimonial-item__quote">
                <img
                  src="/assets/images/icons/quote.svg"
                  alt=""
                  className="quote quote-white"
                />
                <img
                  src="/assets/images/icons/quote-dark.svg"
                  alt=""
                  className="quote quote-dark"
                />
              </div>
              <div className="client-info d-flex align-items-center gap-3">
                <div className="client-info__thumb">
                  <img src="/assets/images/avatars/avatar-5.png" alt="avatar1" />
                </div>
                <div className="client-info__content">
                  <h5 className="client-info__name mb-2">{t("testimonial.feedbacks.1.author")}</h5>
                  
                </div>
              </div>
            </div>
            <div className="testimonial-item hover-bg-main">
              {/* <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg white-version"
              />
              <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg dark-version"
              /> */}
              <div className="testimonial-item__rating mb-3">
                <ul className="star-rating">
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                </ul>
              </div>
              <p className="testimonial-item__desc">
                {t("testimonial.feedbacks.2.feedback")}
              </p>
              <div className="testimonial-item__quote">
                <img
                  src="/assets/images/icons/quote.svg"
                  alt=""
                  className="quote quote-white"
                />
                <img
                  src="/assets/images/icons/quote-dark.svg"
                  alt=""
                  className="quote quote-dark"
                />
              </div>
              <div className="client-info d-flex align-items-center gap-3">
                <div className="client-info__thumb">
                  <img src="/assets/images/avatars/avatar-5.png" alt="" />
                </div>
                <div className="client-info__content">
                  <h5 className="client-info__name mb-2">{t("testimonial.feedbacks.2.author")}</h5>
                  
                </div>
              </div>
            </div>
            <div className="testimonial-item hover-bg-main">
              {/* <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg white-version"
              />
              <img
                src="/assets/images/gradients/testimonial-bg.png"
                alt=""
                className="hover-bg dark-version"
              /> */}
              <div className="testimonial-item__rating mb-3">
                <ul className="star-rating">
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                  <li className="star-rating__item">
                    <i className="fas fa-star" />
                  </li>
                </ul>
              </div>
              <p className="testimonial-item__desc">
                {t("testimonial.feedbacks.3.feedback")}
              </p>
              <div className="testimonial-item__quote">
                <img
                  src="/assets/images/icons/quote.svg"
                  alt=""
                  className="quote quote-white"
                />
                <img
                  src="/assets/images/icons/quote-dark.svg"
                  alt=""
                  className="quote quote-dark"
                />
              </div>
              <div className="client-info d-flex align-items-center gap-3">
                <div className="client-info__thumb">
                  <img src="/assets/images/avatars/avatar-5.png" alt="" />
                </div>
                <div className="client-info__content">
                  <h5 className="client-info__name mb-2">{t("testimonial.feedbacks.3.author")}</h5>
                 
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;

